export const packageLink = (singlePackage: any) => {
  return `/package/${singlePackage.identifier ?? singlePackage.id} `;
};

export const flightLink = (
  type: string,
  identifier: string,
  currentSearchParams: string
) => {
  return `/flight/view/${type}/${identifier}${currentSearchParams}`;
};

export const hotelLink = (identifier: string, currentSearchParams: string) => {
  return `/hotel/${identifier}${currentSearchParams}`;
};

export const attractionLink = (
  identifier: string,
  currentSearchParams: string
) => {
  return `/attractions/${identifier}${currentSearchParams}`;
};

export const dynamicPackageLink = ({
  h_id,
  f_id,
  searchParams,
}: {
  h_id: string;
  f_id?: string;
  searchParams?: string;
}) => {
  const currentSearchParams = new URLSearchParams(window.location.search);
  currentSearchParams.set('h', h_id);
  if (f_id) {
    currentSearchParams.set('f', f_id);
  }
  if (searchParams) {
    const necessaryParamsArr = [
      'from',
      'to',
      'adult',
      'child',
      'infant',
      'destinationCity',
      'boardBasis',
      'hotelStar',
      'multi_room_guests',
    ];
    const filteredParams = Object.fromEntries(
      Object.entries(searchParams).filter(
        ([, value]) => value !== null && value !== undefined
      )
    );

    for (const [key, value] of Object.entries(filteredParams)) {
      if (!necessaryParamsArr.includes(key)) {
        continue;
      }
      if (Array.isArray(value) || typeof value === 'object') {
        currentSearchParams.append(key, JSON.stringify(value));
      } else {
        currentSearchParams.append(key, value);
      }
    }
  }
  return `/dynamicPackage?${currentSearchParams.toString()}`;
};
